var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('v-container',[_c('v-alert',{attrs:{"color":"blue","type":"success","text":""}},[_vm._v(" "+_vm._s(_vm.$t('pas-de-commande-alert'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }